import { ListResponse } from '@/types/common';
import { IStudioInfo, StudioStatus } from '@/types/studio';
import { requestWrapper } from '@/utils/request';

export interface ClassroomInput {
  id?: number;
  name: string;
  capacity: number;
}

// 创建门店需要的参数
export interface CreateStudioParams {
  id?: number; // 门店 ID
  navigation_tips: string; // 导航信息
  classroom_num?: number; // 教室数量
  navigation_address: string; // 导航地址
  start_time: string; // 开始时间
  display_address: string; // 展示地址
  navigation_latitude: string; // 经度
  navigation_longitude: string; // 纬度
  image?: string; // 图片（旧字段）
  image_arr: string[]; // 门头照片
  parking_tips: string; // 停车信息
  end_time: string; // 结束时间
  merchant_id?: number; // 商户 ID
  create_time?: string; // 创建时间
  name: string; // 名称
  status?: number; // 状态
  class_rooms: ClassroomInput[];
}

// 创建教室需要的参数
export interface CreateClassroomParams {
  store_id: number;
  class_rooms: ClassroomInput[];
}

// 创建门店
export async function createStudio(body: CreateStudioParams) {
  return requestWrapper<IStudioInfo>('/api/store/create', {
    method: 'POST',
    data: body,
  });
}

// 更新门店信息
export async function updateStudio(body: Partial<CreateStudioParams>) {
  return requestWrapper<IStudioInfo>('/api/store/update', {
    method: 'POST',
    data: body,
  });
}

// 获取门店列表
export async function getStudioList(
  params: {
    page?: number;
    page_size?: number;
    ids?: number[]; // 门店 ID 列表
    status?: StudioStatus; // 状态 0: 全部， 1: 在线， 2: 下线
  } = {},
) {
  const defaultParams = {
    page: 1,
    page_size: 100,
    ids: [],
    status: StudioStatus.ONLINE,
  };

  const mergedParams = {
    ...defaultParams,
    ...params,
  };

  return requestWrapper<ListResponse<IStudioInfo>>('/api/store/list', {
    method: 'GET',
    params: mergedParams,
  });
}

// 创建教室
export async function createClassroom(body: CreateClassroomParams) {
  return requestWrapper<any>('/api/classroom/create', {
    method: 'POST',
    data: body,
  });
}

// 更新教室信息
export async function updateClassroom(body: {
  store_id: number;
  id: number;
  name: string;
  capacity: number;
}) {
  return requestWrapper<any>('/api/classroom/update_by_id', {
    method: 'POST',
    data: body,
  });
}

// 删除教室
export async function deleteClassroom(body: { class_room_id: number }) {
  return requestWrapper<IStudioInfo>('/api/classroom/delete', {
    method: 'POST',
    data: body,
  });
}
